export const COMPANY = {
  legal: "KOTTAKOTA SMARTTECH SOLUTIONS PVT LTD",
  brand: "WaveLine",
  email: "support@waveline.in",
  grievanceEmail: "grievance@waveline.in",
  phone: "+91 90000 00000",
  address: "Hyderabad, Telangana, India",
  hours: "Mon–Sat, 9:00 AM – 7:00 PM IST",
};
